import {
  REPORT_USER,
  GET_REPORTED_USERS,
  DELETE_REPORT,
  REPORT_USER_ERROR,
  CLEAR_MSG,
} from "../actions/types";

const initialState = {
  msg: "",
  reportedUser: {},
  reportedUsers: [],
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_REPORTED_USERS:
      return {
        ...state,
        reportedUsers: payload,
        loading: false,
      };
    case DELETE_REPORT:
      return {
        ...state,
        reportedUsers: state.reportedUsers.filter(
          (report) => report._id !== payload
        ),
        loading: false,
      };
    case REPORT_USER:
      return {
        ...state,
        msg: payload.msg,
        loading: false,
      };
    case REPORT_USER_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_MSG:
      return {
        ...state,
        msg: "",
      };
    default:
      return state;
  }
}
